import {
  MUTATION_SHOW_CHECKOUT_DIALOG,
} from "@/plugins/store"

export default {
  methods: {
    purchaseValueToString(val) {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(val)
    },
    purchaseProduct(sku) {
      let data = {
        url: window.location.href
      }
      return this.$api.preparePurchaseProduct(sku, data).then((res) => {
        let product = res.data.product;
        let checkoutDialogData = {
          title: product.name,
          price: product.total,
          description: product.description,
          url: res.data.url,
          // name: product.name,
        };
        this.$store.commit(MUTATION_SHOW_CHECKOUT_DIALOG, checkoutDialogData)
      }).catch(() => {});
    }
  }
}
